import React from "react";

import styles from "./IlomePdfModal.module.scss";

const IlomePdfModalView = ({ isVisible, hideModal }) => {
    return (
        <div className={`modal ${isVisible ? "is-active" : ""}`}>
            <div className="modal-background" onClick={hideModal} />
            <div className={`modal-card ${styles.modalCard}`}>
                <button
                    type="button"
                    onClick={hideModal}
                    className={`delete ${styles.closeButton}`}
                    aria-label="close"
                />
                <section className={`modal-card-body ${styles.modalBody}`}>
                    <iframe
                        src="/ilome.pdf"
                        title="Ilomé"
                        className={styles.pdfFrame}
                    />
                </section>
            </div>
        </div>
    );
};

export default IlomePdfModalView;
